"use strict";
// packages/types/src/api/salaries.ts
Object.defineProperty(exports, "__esModule", { value: true });
